import React, { FC } from 'react';

import { Col, Row } from 'antd';
import { IChallengeResourceRender, IChallengeWysiwyg } from 'src/shared/models';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeWysiwyg;
}

const ChallengeWysiwyg: FC<OwnProps> = ({ config }) => {
  if (!config) return <React.Fragment />;
  const { title, content } = config;

  return (
    <Row className="wysiwyg-resource__wrapper">
      <Col xs={24} xl={24} className="wysiwyg-resource__content">
        {title && <h3 className="wysiwyg-resource__content--title">{title}</h3>}
        <span
          className="wysiwyg-resource__content--wysiwyg"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Col>
    </Row>
  );
};

export default ChallengeWysiwyg;
